import { render, staticRenderFns } from "./icyBottom.vue?vue&type=template&id=189ac4a3&scoped=true&"
import script from "./icyBottom.vue?vue&type=script&lang=js&"
export * from "./icyBottom.vue?vue&type=script&lang=js&"
import style0 from "./icyBottom.vue?vue&type=style&index=0&id=189ac4a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ac4a3",
  null
  
)

export default component.exports